import {
  DataLayerEvent,
  DataLayerFormName,
  DataLayerFormStage,
} from '../../../../../../common/utilities/customDatalayerInterface';
import digitalDataAssignment from '../../../../../../common/utilities/digitalDataAssignment';
import { AxiosPromise } from 'axios';
import IDeal from '../../../model/IDeal';
import IDimensions from '../../../model/IDimensions';
import dataLayerToggleVerification from '../../../../../../common/utilities/dataLayerToggleVerification';
import { customerStorage } from '../../../../../../common/service/customerStorage';

const ConfigureDataLayerRest = async (promise: AxiosPromise<IDeal>, dimensions: IDimensions): Promise<void> => {
  try {
    const isDataLayer = dataLayerToggleVerification(dimensions);
    if (isDataLayer) {
      const configuratorDetail = await promise.then(configureDetailResponse => {
        return configureDetailResponse?.data?.fullProductConfiguration;
      });
      const customerStorageValue = customerStorage.getCustomerData(dimensions);

      digitalDataAssignment({
        event: DataLayerEvent.FORM_NAVIGATE,
        form: {
          name: DataLayerFormName.CONFIGURATOR,
          stage: DataLayerFormStage.CONFIGURE_CAR,
          details: {
            configurator: {
              selectedSpec: [
                {
                  nameplate: {
                    code: configuratorDetail?.dmsCode,
                    name: configuratorDetail?.title,
                    modelYear: configuratorDetail?.modelyear,
                    brand: configuratorDetail?.brand,
                    description: configuratorDetail?.dmsDescription,
                  },
                  specPack: {
                    code: configuratorDetail?.nvicCode,
                    name: configuratorDetail?.specPack?.title,
                  },
                  engine: {
                    fuelType: configuratorDetail?.engine?.title,
                    fuelLabel: configuratorDetail?.fuel,
                  },
                  exterior: {
                    colour: configuratorDetail?.exteriorColour?.title,
                    code: configuratorDetail?.exteriorColour?.description,
                  },
                  interior: {
                    colour: configuratorDetail?.interiorColour?.title,
                    code: configuratorDetail?.interiorColour?.description,
                  },
                  bodyType: {
                    bodyStyleType: configuratorDetail?.bodyStyle,
                  },

                  standardFeatures: configuratorDetail?.keyFeatures.map(item => {
                    return {
                      name: item.description,
                      code: item.order?.toString(),
                      category: item.disclaimer,
                    };
                  }),
                  prices: configuratorDetail?.prices.map(item => {
                    return {
                      carPrice: {
                        originalPrice: item?.basePrice,
                        finalPrice: item?.distributionPrice,
                      },
                      currency: item?.currency,
                    };
                  }),
                },
              ],
            },
          },
        },
        user: {
          postCode: customerStorageValue?.postcode,
        },
      });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('DataLayer error', err);
  }
};

export default ConfigureDataLayerRest;
